import {BRAND_CONSTS, AUTH_CONSTS} from "../constants";

export const initialState = {
    brands: {
        itemsList: [],
        hasMore: false,
        badge: undefined,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case BRAND_CONSTS.GET_BRANDS:
            return {
                ...state,
                brands: {
                    itemsList: action.payload.reset ? action.payload.data : [...state.brands.itemsList, ...action.payload.data],
                    badge: action.payload.badge,
                    hasMore: action.payload.hasMore
                }
            };
        case BRAND_CONSTS.ADD_BRAND:
            return {
                ...state,
                brands: {
                    ...state.brands,
                    itemsList: [action.payload, ...state.brands.itemsList],
                }
            };
        case BRAND_CONSTS.UPDATE_BRAND:
            return {
                ...state,
                brands: {
                    ...state.brands,
                    itemsList: state?.brands?.itemsList?.map(product => product.id === action.payload.id ?
                        action.payload : product)
                }
            };
        case BRAND_CONSTS.DELETE_BRAND:
            return {
                ...state,
                brands: {
                    ...state.brands,
                    itemsList: state.brands.itemsList.filter(product => product.id !== action.payload),
                }
            };

        case BRAND_CONSTS.APPEND_BRAND:
            return {
                ...state,
                brands: {
                    ...state.brands,
                    itemsList: [...state.brands.itemsList, action.payload],
                }
            };
        case AUTH_CONSTS.LOG_OUT:
            return initialState;
        default:
            return state;
    }
}
